// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import AttachmentClaim from '@deere/cps-it.warranty-model-factory/lib/claim-attachment';
import actions from '../../action-list';
import {checkClaimValidity} from '../services/claim-validation-helper';
import {formatClaimNumber} from '../../../shared/services/format-claim-number';
import {infoAlertBar} from '../../../shared/services/alert-bar';
import {isClaimEditable} from '../../shared/services/claim-shared-helper';
import {postClaim} from '../../shared/repositories';
import {removeEmptyRows} from '../../shared/services/empty-claim-rows';
import {routerActions} from 'react-router-redux';
import {translate} from '../../../shared/services/translation-service';
import {updateIsActionButtonDisabled} from './is-action-button-disabled';

export const createAttachmentClaim = claim =>

    async (dispatch, getState) => {

        dispatch(busyCounter.increaseBusyCounter());

        updateIsActionButtonDisabled(true)(dispatch);

        const trimmedClaim = removeEmptyRows(claim, AttachmentClaim);
        const isValidClaim = getState().claims.attachment.isValidClaim;

        try {

            const updatedClaim = await postClaim(trimmedClaim, 'attachment-claims');

            const selectedAction = updatedClaim.selectedAction.id;
            const validationStatus = updatedClaim.validationFailed;

            if (checkClaimValidity(isValidClaim, validationStatus, selectedAction)) {

                dispatch({
                    type: actions.UPDATE_CLAIM_ATTACHMENT_IS_VALID_CLAIM,
                    validity: true
                });

            }

            infoAlertBar(translate('CLAIM_UPDATED_SUCCESSFULLY'));

            if (['DRAFT', 'SAVE_VALD'].includes(selectedAction) && updatedClaim.claimNumber) {

                dispatch(routerActions.replace(`/claims/attachment/edit/${formatClaimNumber(updatedClaim.claimNumber)}`));

            }

            dispatch({
                isEditable: isClaimEditable(validationStatus, updatedClaim.selectedAction),
                type: actions.UPDATE_CLAIM_ATTACHMENT_IS_EDITABLE
            });

            dispatch({
                type: actions.SET_CLAIM_ATTACHMENT,
                updatedClaim
            });

        } catch (error) {

        } finally {

            updateIsActionButtonDisabled(false)(dispatch);

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/claim/attachment/action-creators/validate-claim.js